import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TuiHint, TuiIcon } from '@taiga-ui/core';
import { TuiFieldErrorContentPipe, TuiFieldErrorPipe } from '@taiga-ui/kit';
import {
  TuiInputModule,
  TuiInputPasswordModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/legacy';

import { AuthRoutingModule } from './auth-routing.module';
import { InfomercialComponent } from './infomercial/infomercial.component';
import { LandingComponent } from './landing/landing.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { SignInComponent } from './sign-in/sign-in.component';

@NgModule({
  declarations: [
    LandingComponent,
    SignInComponent,
    PasswordResetComponent,
    InfomercialComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    TuiIcon,
    FormsModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiInputPasswordModule,
    ReactiveFormsModule,
    TuiFieldErrorPipe,
    ...TuiHint,
    NgOptimizedImage,
    TuiFieldErrorContentPipe,
  ],
})
export class AuthModule {}
